module.exports = __webpack_public_path__ + "img/40_38_051_500.865aca3a.jpg";